import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { useGlobalComponent } from '@/components'
import { usePlugins } from '@/plugins'
import { useGlobalDirectives } from '@/directives'
import { growingIo } from '@jsh/helper/utils'
import './registerServiceWorker'
import '@/assets/styles/index.less'
import '@icon-park/vue-next/styles/index.css'
import './install'

/** Chromium 无害警告：组件库布局测量触发的 ResizeObserver 循环通知 */
window.addEventListener('error', (e) => {
  const msg = e.message || ''
  if (
    msg.includes('ResizeObserver loop completed with undelivered notifications') ||
    msg.includes('ResizeObserver loop limit exceeded')
  ) {
    e.stopImmediatePropagation()
  }
})

growingIo.init({
  projectId: '92e3bf168f23aef6'
})

const app = createApp(App)
useGlobalComponent(app)
usePlugins(app)
useGlobalDirectives(app)

app.use(store).use(router).mount('#app')
